export const EVOLUTION_TABLE: Record<number, { evolvesTo: number; level: number }> = {
  1: { evolvesTo: 2, level: 16 },  // Salespup → Pitchdog
  3: { evolvesTo: 4, level: 16 },  // Byte → Debuggor
  5: { evolvesTo: 6, level: 18 },  // Qubit → Stonkzilla
  7: { evolvesTo: 8, level: 14 },  // Vibecat → Brandlion
  9: { evolvesTo: 10, level: 20 }, // Opster → Sysmonk
  13: { evolvesTo: 14, level: 18 }, // Recruitling → Hiremaster
  15: { evolvesTo: 16, level: 16 }, // Supportpup → Helpmaid
  17: { evolvesTo: 18, level: 16 }, // Buzzlet → Trendlion
  19: { evolvesTo: 20, level: 20 }, // Ledgeling → Auditlord
  21: { evolvesTo: 22, level: 20 }, // Scriptlet → Algomancer
  23: { evolvesTo: 24, level: 22 }, // Deploybot → Inframonk
};
